class StickyATC extends HTMLElement {
  connectedCallback() {
    this.variantInput = this.querySelector(".sticky-atc__variant-id");
    this.sizeButtons = this.querySelectorAll(".sticky-atc__size");
    this.addBtn = this.querySelector("[data-add]");

    // Always visible (mobile only via CSS)
    this.classList.add("is-visible");

    // Size selection
    this.sizeButtons.forEach((btn) => {
      btn.addEventListener("click", () => {
        this.sizeButtons.forEach((b) => b.classList.remove("is-active"));
        btn.classList.add("is-active");
        this.updateVariant(btn.dataset.size);
      });
    });

    // Add to cart -> use Dawn cart drawer behavior
    this.addBtn.addEventListener("click", async () => {
      const id = this.variantInput.value;
      if (!id) return;

      this.addBtn.disabled = true;

      try {
        // 1) Add item
        await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
        });

        // 2) Refresh cart drawer section and OPEN it (Dawn)
        await this.openCartDrawer();
      } catch (e) {
        console.error(e);
      } finally {
        this.addBtn.disabled = false;
      }
    });
  }

  async updateVariant(size) {
    try {
      const handle = this.dataset.productHandle;
      const res = await fetch(`/products/${handle}.js`);
      const product = await res.json();

      const variant = product.variants.find((v) => v.options && v.options.includes(size));
      if (variant) {
        this.variantInput.value = variant.id;

        if (!variant.available) {
          this.addBtn.disabled = true;
          this.addBtn.textContent = "SOLD OUT";
        } else {
          this.addBtn.disabled = false;
          this.addBtn.textContent = "ADD TO CART";
        }
      }
    } catch (e) {
      console.error(e);
    }
  }

  async openCartDrawer() {
    const drawer = document.querySelector("cart-drawer");
    if (!drawer) {
      // If no drawer in theme, fallback to cart page
      window.location.href = `${window.Shopify.routes.root}cart`;
      return;
    }

    // Refresh drawer content via section rendering
    try {
      const res = await fetch(`${window.Shopify.routes.root}?section_id=cart-drawer`);
      const text = await res.text();
      const html = new DOMParser().parseFromString(text, "text/html");
      const newDrawer = html.querySelector("cart-drawer");
      if (newDrawer) drawer.innerHTML = newDrawer.innerHTML;
    } catch (e) {
      console.error("Drawer refresh failed", e);
    }

    // Open drawer (Dawn method)
    if (typeof drawer.open === "function") {
      drawer.open();
    } else {
      // fallback class
      drawer.classList.add("active");
    }
  }
}

customElements.define("sticky-atc", StickyATC);
